import { render, staticRenderFns } from "./LiveDiagram.vue?vue&type=template&id=6206c8fb&scoped=true"
import script from "./LiveDiagram.vue?vue&type=script&lang=js"
export * from "./LiveDiagram.vue?vue&type=script&lang=js"
import style0 from "./LiveDiagram.vue?vue&type=style&index=0&id=6206c8fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6206c8fb",
  null
  
)

export default component.exports